<div *ngIf="assistancePrice" class="price-info-panel">
  <div class="price-attributes-panel">
    <p *ngIf="assistancePrice.price_weekday">
      <strong>{{ 'Price Weekday' | translate }}:</strong>
      {{ assistancePrice.price_weekday | currencyFormat }}
    </p>
    <p *ngIf="assistancePrice.price_weekend">
      <strong>{{ 'Price Weekend' | translate }}:</strong>
      {{ assistancePrice.price_weekend | currencyFormat }}
    </p>
    <p *ngIf="assistancePrice.price_saturday">
      <strong>{{ 'Price Saturday' | translate }}:</strong>
      {{ assistancePrice.price_saturday | currencyFormat }}
    </p>
    <p *ngIf="assistancePrice.price_sunday">
      <strong>{{ 'Price Sunday' | translate }}:</strong>
      {{ assistancePrice.price_sunday | currencyFormat }}
    </p>
    <p *ngIf="assistancePrice.price_holiday">
      <strong>{{ 'Price Holiday' | translate }}:</strong>
      {{ assistancePrice.price_holiday | currencyFormat }}
    </p>
    <p *ngIf="assistancePrice.price_extra">
      <strong>{{ 'Price Extra' | translate }}:</strong>
      {{ assistancePrice.price_extra | currencyFormat }}
    </p>
    <p *ngIf="assistancePrice.price_night">
      <strong>{{ 'Price Night' | translate }}:</strong>
      {{ assistancePrice.price_night | currencyFormat }}
    </p>
    <p *ngIf="assistancePrice.hour_start">
      <strong>{{ 'Hour Start' | translate }}:</strong>
      {{ assistancePrice.hour_start }}
    </p>
    <p *ngIf="assistancePrice.hour_end">
      <strong>{{ 'Hour End' | translate }}:</strong>
      {{ assistancePrice.hour_end }}
    </p>
    <p *ngIf="assistancePrice.max_amount">
      <strong>{{ 'Max Amount' | translate }}:</strong>
      {{ assistancePrice.max_amount | currencyFormat }}
    </p>
    <p *ngIf="assistancePrice.price_cancellation">
      <strong>{{ 'Price Cancellation' | translate }}:</strong>
      {{ assistancePrice.price_cancellation }} %
    </p>
    <p *ngIf="assistancePrice.note">
      <strong>{{ 'Note' | translate }}:</strong>
      {{ assistancePrice.note }}
    </p>
  </div>

  <div class="price-extra-panel" *ngIf="assistancePrice.assistance_price_extras.length > 0">
    <div *ngFor="let extra of assistancePrice.assistance_price_extras; let i = index">
      <p>
        <strong>{{ extra.name }}:</strong>
        {{ extra.price }}
      </p>
    </div>
  </div>
</div>